import React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import styles from './PagesStyle/FooterStyles';

const Footer = ({ pageNumber }) => (
  <View style={styles.footerContainer}>
    {/* Empty space on the left (or you can add something else here) */}
    <View style={{ width: 50 }} /> 


    {/* Render page numbers dynamically in the center */}
    <View style={styles.footerTextContainer}>
      {pageNumber === 5 && (
            <Text style={styles.page5footer}>
              The contents of this report shall be treated as intellectual property and cannot be duplicated, cloned, copied,
              {'\n'}reproduced, modified or erased without the author's written consent.
            </Text>
          )}
      <Text
        render={({ pageNumber, totalPages }) => (
          `PAGE ${pageNumber} / ${totalPages}`
        )}
        style={styles.footerText}
      />
    </View>

    {/* Display the logo on the right */}
    <Image
      style={styles.footerBadge}
      src="/logoh.png" // Ensure the correct path to your logo image
    />
  </View>
);

export default Footer;
